function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6e37fa;}.cls-2{fill:#f40953;}.cls-3{fill:#ff9408;}.cls-4{fill:#32bbb9;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M322.38,43.31V153.55a6.6,6.6,0,0,0,9.9,5.72l95.48-55.13a6.6,6.6,0,0,0,0-11.43L332.28,37.59A6.6,6.6,0,0,0,322.38,43.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M108.67,209.43V99.18a6.59,6.59,0,0,0-9.89-5.71L3.3,148.59A6.6,6.6,0,0,0,3.3,160l95.48,55.12A6.59,6.59,0,0,0,108.67,209.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M161.25,136.16V246.41a6.6,6.6,0,0,0,9.9,5.72L266.63,197a6.6,6.6,0,0,0,0-11.43l-95.48-55.12A6.6,6.6,0,0,0,161.25,136.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M270.26,116.86V6.61A6.6,6.6,0,0,0,260.37.89L164.89,56a6.6,6.6,0,0,0,0,11.43l95.48,55.12A6.59,6.59,0,0,0,270.26,116.86Z"
})));

var SvgNSquare = function SvgNSquare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 431.06 253.02",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/n_square.9b20e9e8.svg";
export { ForwardRef as ReactComponent };